var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import ApplicationOrderService from '../../api/ApplicationOrderService';
import Dialog from './Dialog.vue';
import ArtMsglist from '../../components/alert/ArtMsglist.vue';
var ApplicationOrderType = (function (_super) {
    __extends(ApplicationOrderType, _super);
    function ApplicationOrderType() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = document.documentElement.clientHeight - 240;
        return _this;
    }
    ApplicationOrderType.prototype.created = function () {
        this.service = ApplicationOrderService.getInstance();
        this.getList();
    };
    ApplicationOrderType.prototype.deleteType = function () {
        var _this = this;
        if (!this.checkSelectIds())
            return;
        this.$confirm('请确认是否删除选择的类别').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var type_ids = _this.getSelectIds();
            _this.service
                .deleteType({
                type_ids: type_ids,
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code === 0) {
                    _this.$message.success(res.data.msg || '删除成功');
                    _this.getList();
                    window._czc.push(['_trackEvent', '费用类别', '删除']);
                    return;
                }
                else if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                }
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data,
                    },
                }, {
                    title: '提示',
                    width: 450,
                    height: 350,
                }).instance;
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    ApplicationOrderType.prototype.createType = function () {
        this.operation('add');
    };
    ApplicationOrderType.prototype.updateType = function (row) {
        this.operation('update', row);
    };
    ApplicationOrderType.prototype.operation = function (type, row) {
        var _this = this;
        var instance = this.$dialog(Dialog, {
            data: {
                type: row,
            },
        }, {
            title: (type === 'add' ? '添加' : '修改') + "\u8D39\u7528\u7C7B\u522B",
            width: 500,
            height: 240,
        }).instance;
        instance.$on('submit:ok', function () {
            _this.getList();
            window._czc.push(['_trackEvent', '费用类别', type === 'add' ? '添加' : '修改']);
        });
    };
    ApplicationOrderType.prototype.getSelectIds = function () {
        var type_ids = this.selectRows.map(function (item) { return item.type_id; });
        return type_ids.join(',');
    };
    ApplicationOrderType.prototype.checkSelectIds = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return false;
        }
        else {
            return true;
        }
    };
    ApplicationOrderType.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    ApplicationOrderType.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getTypeList(pager)
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data || { data: [], total: 0 };
            _this.listData = Array.isArray(DATA.data) ? DATA.data : [];
            _this.total = DATA.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    ApplicationOrderType.prototype.pageChange = function () {
        this.getList();
    };
    ApplicationOrderType = __decorate([
        Component
    ], ApplicationOrderType);
    return ApplicationOrderType;
}(Vue));
export default ApplicationOrderType;
